// extracted by mini-css-extract-plugin
export var content = "_mr-1";
export var divider = "_mr-0";